module.exports = __webpack_public_path__ + "img/labels.f0f05290.png";